import React, { memo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { PathName } from 'appConstants';
import { Image } from 'components';
import { ekiHugIcon } from 'assets/images';
import styles from './styles.module.scss';

export const EclipseDriveButton = memo(() => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(PathName.EclipseDrive);
  }, [navigate]);

  return (
    <button
      className={styles.eclipse_drive_button}
      onClick={handleClick}
    >
      <span className={styles.eclipse_drive_text}>Eclipse Drive</span>
      <Image
        url={ekiHugIcon}
        className={styles.eclipse_drive_icon}
      />
    </button>
  );
});
